var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedInColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#0079B2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6988 10.5562C11.6986 10.9688 11.5345 11.3643 11.2427 11.6559C10.9508 11.9475 10.5551 12.1111 10.1426 12.1109C9.73005 12.1107 9.33449 11.9467 9.04293 11.6548C8.75137 11.3629 8.58768 10.9672 8.58789 10.5547C8.5881 10.1422 8.75217 9.7466 9.04403 9.45504C9.33588 9.16348 9.7316 8.99979 10.1441 9C10.5567 9.00021 10.9522 9.16428 11.2438 9.45614C11.5354 9.74799 11.699 10.1437 11.6988 10.5562ZM11.7455 13.2628H8.63455V23H11.7455V13.2628ZM16.6608 13.2628H13.5654V23H16.6297V17.8903C16.6297 15.0438 20.3395 14.7793 20.3395 17.8903V23H23.4115V16.8326C23.4115 12.0339 17.9207 12.2128 16.6297 14.5694L16.6608 13.2628Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInColor);
export default __webpack_public_path__ + "static/media/linkedInColor.51c3eb7513d1e771fb37a3502c314355.svg";
export { ForwardRef as ReactComponent };